// Auto-generated from table Pages

export const pages: { name: string; displayName: string; iconName: string }[] = [
  { name: "AccountDetails", displayName: "account details", iconName: "account" },
  { name: "AccountEdit", displayName: "account edit", iconName: "account" },
  { name: "ActivityCreate", displayName: "activity create", iconName: "activity" },
  { name: "ActivityDetails", displayName: "activity details", iconName: "activity" },
  { name: "ActivityEdit", displayName: "activity edit", iconName: "activity" },
  { name: "AdminPanelDetails", displayName: "admin panel details", iconName: "admin panel" },
  { name: "AdminPanelEdit", displayName: "admin panel edit", iconName: "admin panel" },
  { name: "CategoryCreate", displayName: "category create", iconName: "category" },
  { name: "CategoryDetails", displayName: "category details", iconName: "category" },
  { name: "CategoryEdit", displayName: "category edit", iconName: "category" },
  { name: "ClaimActionCreate", displayName: "claim action create", iconName: "claim action" },
  { name: "ClaimActionDetails", displayName: "claim action details", iconName: "claim action" },
  { name: "ClaimActionEdit", displayName: "claim action edit", iconName: "claim action" },
  { name: "ClaimCreate", displayName: "claim create", iconName: "claim" },
  { name: "ClaimDetails", displayName: "claim details", iconName: "claim" },
  { name: "ClaimEdit", displayName: "claim edit", iconName: "claim" },
  { name: "ContactCreate", displayName: "contact create", iconName: "contact" },
  { name: "ContactDetails", displayName: "contact details", iconName: "contact" },
  { name: "ContactEdit", displayName: "contact edit", iconName: "contact" },
  { name: "ContactPhotoDetails", displayName: "contact photo details", iconName: "contact photo" },
  { name: "ContactPhotoEdit", displayName: "contact photo edit", iconName: "" },
  { name: "ContactTypeCreate", displayName: "contact type create", iconName: "contact type" },
  { name: "ContactTypeDetails", displayName: "contact type details", iconName: "contact type" },
  { name: "ContactTypeEdit", displayName: "contact type edit", iconName: "contact type" },
  { name: "Contractors", displayName: "contractors", iconName: "contractors" },
  { name: "CreditTypeCreate", displayName: "credit type create", iconName: "" },
  { name: "CreditTypeDetails", displayName: "credit type details", iconName: "" },
  { name: "CreditTypeEdit", displayName: "credit type edit", iconName: "" },
  { name: "DomainCreate", displayName: "domain create", iconName: "domain" },
  { name: "DomainDetails", displayName: "domain details", iconName: "domain" },
  { name: "DomainEdit", displayName: "domain edit", iconName: "domain" },
  { name: "DomainPhotoDetails", displayName: "domain photo details", iconName: "domain photo" },
  { name: "DomainPhotoEdit", displayName: "domain photo edit", iconName: "" },
  { name: "DomainUserCreate", displayName: "domain user create", iconName: "domain user" },
  { name: "DomainUserDetails", displayName: "domain user details", iconName: "domainuser" },
  { name: "DomainUserDomainPhotoDetails", displayName: "domain user domain photo details", iconName: "domain user photo" },
  { name: "DomainUserEdit", displayName: "domain user edit", iconName: "domain user" },
  { name: "DomainUserProfilePhotoDetails", displayName: "domain user profile photo details", iconName: "" },
  { name: "EmailChange", displayName: "email change", iconName: "" },
  { name: "FunctionCreate", displayName: "function create", iconName: "function" },
  { name: "FunctionDetails", displayName: "function details", iconName: "function" },
  { name: "FunctionEdit", displayName: "function edit", iconName: "function" },
  { name: "FunctionMemberCreate", displayName: "function member create", iconName: "function member" },
  { name: "FunctionMemberDetails", displayName: "function member details", iconName: "function member" },
  { name: "FunctionMemberEdit", displayName: "function member edit", iconName: "function member" },
  { name: "Home", displayName: "home", iconName: "home" },
  { name: "ImageDetails", displayName: "image details", iconName: "image" },
  { name: "ImageEdit", displayName: "image edit", iconName: "image" },
  { name: "Invitation", displayName: "invitation", iconName: "" },
  { name: "Login", displayName: "login", iconName: "login" },
  { name: "NoticeCreate", displayName: "notice create", iconName: "notice" },
  { name: "NoticeDetails", displayName: "notice details", iconName: "notice" },
  { name: "NoticeEdit", displayName: "notice edit", iconName: "notice" },
  { name: "NoticePhotoDetails", displayName: "notice photo details", iconName: "notice photo" },
  { name: "NoticePhotoEdit", displayName: "notice photo edit", iconName: "" },
  { name: "ObservationTypeCreate", displayName: "observation type create", iconName: "" },
  { name: "ObservationTypeDetails", displayName: "observation type details", iconName: "" },
  { name: "ObservationTypeEdit", displayName: "observation type edit", iconName: "" },
  { name: "PageComponentCreate", displayName: "page component create", iconName: "page component" },
  { name: "PageComponentDetails", displayName: "page component details", iconName: "page component" },
  { name: "PageComponentEdit", displayName: "page component edit", iconName: "page component" },
  { name: "PageCreate", displayName: "page create", iconName: "page" },
  { name: "PageDetails", displayName: "page details", iconName: "page" },
  { name: "PageEdit", displayName: "page edit", iconName: "page" },
  { name: "PasswordChange", displayName: "password change", iconName: "" },
  { name: "ProjectCreate", displayName: "project create", iconName: "order" },
  { name: "ProjectDetails", displayName: "project details", iconName: "order" },
  { name: "ProjectEdit", displayName: "project edit", iconName: "order" },
  { name: "ProjectMemberCreate", displayName: "project member create", iconName: "member" },
  { name: "ProjectMemberDetails", displayName: "project member details", iconName: "member" },
  { name: "ProjectMemberEdit", displayName: "project member edit", iconName: "member" },
  { name: "ProjectMemberPhotoDetails", displayName: "project member photo details", iconName: "member photo" },
  { name: "ProjectPhotoDetails", displayName: "project photo details", iconName: "order photo" },
  { name: "ProjectPhotoEdit", displayName: "project photo edit", iconName: "" },
  { name: "RoleCreate", displayName: "role create", iconName: "role" },
  { name: "RoleDetails", displayName: "role details", iconName: "role" },
  { name: "RoleEdit", displayName: "role edit", iconName: "role" },
  { name: "Settings", displayName: "settings", iconName: "" },
  { name: "TaskCreate", displayName: "task create", iconName: "task" },
  { name: "TaskDetails", displayName: "task details", iconName: "task" },
  { name: "TaskEdit", displayName: "task edit", iconName: "task" },
  { name: "TaskPhotoDetails", displayName: "task photo details", iconName: "photo" },
  { name: "Tasks", displayName: "tasks", iconName: "tasks" },
  { name: "TaskTypeCreate", displayName: "task type create", iconName: "" },
  { name: "TaskTypeDetails", displayName: "task type details", iconName: "" },
  { name: "TaskTypeEdit", displayName: "task type edit", iconName: "" },
  { name: "ThemeCreate", displayName: "theme create", iconName: "theme" },
  { name: "ThemeDetails", displayName: "theme details", iconName: "theme" },
  { name: "ThemeEdit", displayName: "theme edit", iconName: "theme" },
  { name: "UserCreate", displayName: "user create", iconName: "user" },
  { name: "UserPhotoDetails", displayName: "user photo details", iconName: "user photo" },
  { name: "UserPhotoEdit", displayName: "user photo edit", iconName: "" },
];
export type TPages = keyof typeof pages;
